export interface IPhoneNumber {
  type: string;
  value: string | null;
  primary: boolean;
}

/** Webex People API `phoneNumbers[].type` for primary PSTN line. */
export const PHONE_TYPE_WORK = 'work';

/** Webex People API `phoneNumbers[].type` when only an extension is assigned. */
export const PHONE_TYPE_WORK_EXTENSION = 'work_extension';

/**
 * Chooses the number to show as "My number" / business line: prefer `work` (PSTN),
 * else `work_extension` when the user has extension-only calling (matches Webex app).
 */
export function pickDisplayBusinessPhone(
  phoneNumbers: IPhoneNumber[] | undefined | null
): IPhoneNumber | undefined {
  if (!phoneNumbers?.length) {
    return undefined;
  }
  const hasValue = (p: IPhoneNumber) =>
    p?.value != null && String(p.value).trim() !== '';

  const primaryWork = phoneNumbers.find(
    (p) => p?.type === PHONE_TYPE_WORK && p?.primary && hasValue(p)
  );
  if (primaryWork) {
    return primaryWork;
  }

  const primaryWorkExtension = phoneNumbers.find(
    (p) => p?.type === PHONE_TYPE_WORK_EXTENSION && p?.primary && hasValue(p)
  );
  if (primaryWorkExtension) {
    return primaryWorkExtension;
  }

  const work = phoneNumbers.find(
    (p) => p?.type === PHONE_TYPE_WORK && hasValue(p)
  );
  if (work) {
    return work;
  }
  return phoneNumbers.find(
    (p) => p?.type === PHONE_TYPE_WORK_EXTENSION && hasValue(p)
  );
}

export interface IBusinessNumberResponse {
  id: string;
  emails: string[];
  phoneNumbers: IPhoneNumber[];
  displayName: string;
  nickName: string;
  firstName: string;
  lastName: string;
  userName: string;
  orgId: string;
  created: string;
  lastModified: string;
  lastActivity: string;
  status: string;
  type: string;
}

export interface IErrorResponse {
  response?: IResponseData;
}

export interface IResponseData {
  status?: string;
}

export enum MAKE_A_CALL_KEYS {
  MAKE_A_CALL_TOKEN = "makeAcallToken",
  CALL_FORWARD_SETTING_INTERVAL = "callForwardSettingInterval",
  DO_NOT_FORWARD_CALL = "Do not forward calls",
}

export enum UserProfileMenuItemsKeys {
  SIGN_OUT = 'signout',
  ATTENDANT_CONSOLE = "attendantConsole",
  CX_ESSENTIALS = "cxEssentials",
  E911 = "e911",
  CALLING_WIDGET = "callingWidget",
} 